angular.module('NumbersEditor')
    .factory('HomeFactory', [
        '$http', function($http) {

            var urlBase = '/api/home';
            var homeFactory = {};

            homeFactory.getTodaysGames = function (fromDate, toDate) {
                var fromDateParam = new Date(fromDate).toDateString();
                var toDateParam = new Date(toDate).toDateString();
                return $http.get(urlBase + '/getWithFilter?fromDate=' + fromDateParam + '&toDate=' + toDateParam);
            };

            homeFactory.getUpcomingGames = function() {
                return $http.get(urlBase + '/upcoming');
            };

            return homeFactory;
        }
    ]);